/* DK brand — dodaje .dk-scrolled na header pri skrolu (shrink + jači blur) */
(function () {
  function init() {
    var header = document.querySelector('.header-wrapper') || document.querySelector('.header');
    if (!header) return;
    var ticking = false;
    function update() {
      if (window.scrollY > 30) header.classList.add('dk-scrolled');
      else header.classList.remove('dk-scrolled');
      ticking = false;
    }
    window.addEventListener('scroll', function () {
      if (!ticking) { window.requestAnimationFrame(update); ticking = true; }
    }, { passive: true });
    update();
  }
  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);
})();

/* DK — max. 5 komada po knjizi (proizvodi ciji naslov pocinje sa "Buch").
   Shopify za D2C nema ugradjen max, pa se ogranicava u temi:
   max na input poljima + korekcija korpe posle svake izmene i pre checkout-a.
   Ne pokriva direktne cart permalinke (/cart/<variant>:<qty>). */
(function () {
  var MAX = 5;
  var MSG = 'Maximal ' + MAX + ' Exemplare pro Buch und Bestellung.';
  var nativeFetch = window.fetch.bind(window);
  var bookVariants = {};

  function isBook(title) { return /^Buch\b/i.test(title || ''); }

  function notice() {
    var el = document.getElementById('dk-qty-notice');
    if (!el) {
      el = document.createElement('div');
      el.id = 'dk-qty-notice';
      el.setAttribute('role', 'status');
      el.style.cssText = 'position:fixed;left:50%;bottom:24px;transform:translateX(-50%);z-index:9999;' +
        'background:#171717;color:#fafafa;border:1px solid #bc9844;border-radius:0.625rem;' +
        'padding:12px 18px;font:500 14px/1.4 Poppins,sans-serif;box-shadow:0 8px 24px rgba(0,0,0,.4);max-width:calc(100% - 32px)';
      document.body.appendChild(el);
    }
    el.textContent = MSG;
    clearTimeout(el._t);
    el._t = setTimeout(function () { el.remove(); }, 6000);
  }

  function applyMax() {
    document.querySelectorAll('input[data-quantity-variant-id]').forEach(function (input) {
      if (bookVariants[input.dataset.quantityVariantId]) input.max = MAX;
    });
  }

  // vraca true ako je korpa korigovana
  function enforceCart() {
    return nativeFetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var over = [];
        cart.items.forEach(function (it) {
          if (!isBook(it.product_title)) return;
          bookVariants[it.variant_id] = true;
          if (it.quantity > MAX) over.push(it.key);
        });
        applyMax();
        return over.reduce(function (p, key) {
          return p.then(function () {
            return nativeFetch('/cart/change.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
              body: JSON.stringify({ id: key, quantity: MAX })
            });
          });
        }, Promise.resolve()).then(function () { return over.length > 0; });
      })
      .catch(function () { return false; });
  }

  function enforceAndRefresh() {
    return enforceCart().then(function (changed) {
      if (changed) {
        try { sessionStorage.setItem('dk-qty-notice', '1'); } catch (e) {}
        location.reload();
      }
      return changed;
    });
  }

  // posle svakog AJAX poziva teme/aplikacija koji menja korpu
  window.fetch = function (input, init) {
    var url = typeof input === 'string' ? input : (input && input.url) || '';
    var p = nativeFetch(input, init);
    if (/\/cart\/(add|change|update)/.test(url)) {
      p.then(function () { setTimeout(enforceAndRefresh, 0); });
    }
    return p;
  };

  // pre odlaska na checkout iz korpe / drawer-a
  document.addEventListener('submit', function (e) {
    var btn = e.submitter;
    var toCheckout = (btn && btn.name === 'checkout') || /\/checkout/.test(e.target.action || '');
    if (!toCheckout) return;
    e.preventDefault();
    enforceCart().then(function (changed) {
      if (changed) {
        try { sessionStorage.setItem('dk-qty-notice', '1'); } catch (err) {}
        location.reload();
      } else {
        location.href = '/checkout';
      }
    });
  }, true);

  // product stranica knjige: max na polju za kolicinu
  function initProduct() {
    var m = location.pathname.match(/\/products\/([^/?#]+)/);
    if (!m) return;
    nativeFetch('/products/' + m[1] + '.js')
      .then(function (r) { return r.json(); })
      .then(function (p) {
        if (!isBook(p.title)) return;
        p.variants.forEach(function (v) { bookVariants[v.id] = true; });
        document.querySelectorAll('input[name="quantity"]').forEach(function (i) { i.max = MAX; });
        applyMax();
      })
      .catch(function () {});
  }

  function init() {
    try {
      if (sessionStorage.getItem('dk-qty-notice')) { sessionStorage.removeItem('dk-qty-notice'); notice(); }
    } catch (e) {}
    initProduct();
    enforceAndRefresh();
    // Dawn re-renderuje stavke korpe posle izmena -> ponovo postavi max
    new MutationObserver(applyMax).observe(document.body, { childList: true, subtree: true });
  }
  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);
})();
